import type { Row } from "@rocicorp/zero";
import { styled } from "goober";
import { makeUrl, routes } from "../lib/urls";
import { Avatar } from "./Avatar";
import { Icon } from "./Icon";
import { ServiceAccountAvatar } from "./ServiceAccountAvatar";
import { Text } from "./Text";

export type PrincipalPreview = {
  id: string;
  name: string;
  kind: "group" | "user" | "serviceAccount";
  user?: Row["user"];
};

const PrincipalLink = styled("a")`
  all: unset;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  min-width: 0;

  & > span:not(.arrow-icon) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }

  &:hover {
    background: var(--alpha4);
  }

  & .arrow-icon {
    margin-left: auto;
    opacity: 0;
    flex-shrink: 0;
    display: flex;
  }

  &:hover .arrow-icon {
    opacity: 0.5;
  }
`;

const PrincipalIcon = styled("div")`
  display: flex;
  flex-shrink: 0;
`;

export function PrincipalRow({ principal }: { principal: PrincipalPreview }) {
  return (
    <PrincipalLink
      href={
        principal.kind === "group"
          ? makeUrl(routes.modal.group, { id: principal.id })
          : principal.kind === "serviceAccount"
            ? makeUrl(routes.modal.serviceAccount, { id: principal.id })
            : makeUrl(routes.modal.member, { id: principal.id })
      }
      target="_blank"
      rel="noopener noreferrer"
    >
      <PrincipalIcon>
        {principal.kind === "group" ? (
          <Icon name="users-round" size={16} color="var(--text-primary)" />
        ) : principal.kind === "serviceAccount" ? (
          <ServiceAccountAvatar seed={principal.id} size={16} />
        ) : principal.user ? (
          <Avatar user={principal.user} size={16} tooltip={false} />
        ) : (
          <Icon name="id-card" size={16} color="var(--text-primary)" />
        )}
      </PrincipalIcon>
      <Text variant="text-regular" color="var(--text-primary)" ellipsis>
        {principal.name}
      </Text>
      <span className="arrow-icon">
        <Icon name="arrow-up-right" size={12} />
      </span>
    </PrincipalLink>
  );
}
